var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import PersistentCollection from '../PersistentCollection';
import FilterRuleContainsString from '../filters/FilterRuleContainsString';
import ServiceSchemaModel from '../../models/ServiceSchemaModel';
import { observable } from 'mobx';
import SortModel from '../../models/SortModel';
import { compareNumbers, compareStrings } from '../../utils/compareUtils';
/**
 *
 */
var ServiceSchemaCollection = /** @class */ (function (_super) {
    __extends(ServiceSchemaCollection, _super);
    /**
     *
     */
    function ServiceSchemaCollection() {
        var _this = _super.call(this, ServiceSchemaModel, true, 'ServiceSchemaCollection') || this;
        _this.searchStringFilter = new FilterRuleContainsString('filterString');
        _this.sort = new SortModel({ fieldName: 'name', direction: -1 });
        _this.filter.addRule(_this.searchStringFilter);
        return _this;
    }
    /**
     *
     * @param items
     * @return {*}
     * @private
     */
    ServiceSchemaCollection.prototype.applySort = function (items) {
        var sort = this.sort;
        if (!sort)
            return items;
        var result = items.concat([]);
        result.sort(function (a, b) {
            switch (sort.fieldName) {
                case 'name':
                    return compareStrings(a.name, b.name);
                case 'description':
                    return compareStrings(a.description, b.description);
                case 'triggerType':
                    return compareNumbers(a.triggerType, b.triggerType);
                case 'triggerIntervalValue':
                    return compareNumbers(a.triggerIntervalValue, b.triggerIntervalValue);
                case 'triggerReminderBeforeIntervalValue':
                    return compareNumbers(a.triggerReminderBeforeIntervalValue, b.triggerReminderBeforeIntervalValue);
                default:
                    return compareStrings(a[sort.fieldName], b[sort.fieldName]);
            }
        });
        if (sort.direction < 0) {
            result.reverse();
        }
        return result;
    };
    __decorate([
        observable
    ], ServiceSchemaCollection.prototype, "sort", void 0);
    return ServiceSchemaCollection;
}(PersistentCollection));
export default ServiceSchemaCollection;
